import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { withUnistyles } from 'react-native-unistyles'

const UniBottomSheetTextInput = withUnistyles(BottomSheetTextInput)

export default UniBottomSheetTextInput
